import { makeStyles } from '../../styles/tss-react';

export const useStyles = makeStyles({ name: 'AddressTextField' })(() => ({
  autocompleteSuggestionText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  autocompleteDropdown: {
    maxHeight: 300,
    overflow: 'auto',
  },
  googleLogoListItem: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  googleLogo: { height: 16 },
}));
